import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import cn from 'classname';

import map from 'lodash/map';
import capitalize from 'lodash/capitalize';
import values from 'lodash/values';

import checkboxField from '../../../shared/form-elements/checkbox';
import radioField from './radio-field';
import Tooltip from '../../../shared/tooltip';
import { mapTableSortHeaders, showMoreRows } from '../../../shared/table-helpers';

import Animated from '../../../shared/animation';

import ImagePlaceholdered from '../../../shared/image-placeholdered';
import OfferPromoLabels from '../../../shared/offer-promo-labels';
import get from 'lodash/get';

import DownloadLanding from './download-landing';

lessRequire('modules/streams/components/display-type/list.less');

const List = (props) => {
	const {
		data,
		type,
		isOtherAdv,
		isEditMode,
		tableHeaders,
		sortByColumn,
		columnSorting,
		showMore,
		shouldShowSplitTooltip,
		formData,
		intl,
		checkLandingsPopups,
		streamId,
		selectedLandings,
		offerGeoStats,
		user,
		canEdit
	} = props;

	const fields = formData && formData.values || {};
	const paginatedData = data && data.paginated && data.paginated.data;
	const paginatedDataToShow = !isOtherAdv && isEditMode && paginatedData ?
		paginatedData.filter(row => (row.id === selectedLandings[0])):
		paginatedData;
	return (
		<div className={shouldShowSplitTooltip ? 'stream-table-wrapper' : ''}>
			<div className="list-view">
				<Animated>
					<table className="dashboard-table stream-table">
						<thead className="dashboard-table__head font-proxima-nova-semibold">
							<tr>
								<th>
									<span>#</span>
									<span className="preview-title">{intl('Лендинг')}</span>
								</th>
								{mapTableSortHeaders({
									headers: values(tableHeaders.list),
									columnSorting,
									sortByColumn: e => sortByColumn(e, 'list'),
									intl
								}).map((header, i) => <th key={i} className={i == 0 ? 'title-date' : ''}>{header}</th>)}
								<th>
									<span>{intl('Скачать')}</span>
								</th>
							</tr>
						</thead>
						<tbody className="dashboard-table__body">
							{ data && data.paginated && map(paginatedDataToShow, row => {
								const controlId = isOtherAdv
									? type === 'landings' ? `landing_pages_id_${row.id}` :`transit_pages_id_${row.id}`
									: type === 'landings'	? `landing_pages${row.id}` : `transit_pages${row.id}`;

								const activeLand = fields && isOtherAdv
									? fields[`landing_pages_id_${row.id}`] == true
									: fields.landing_pages == row.id;
								const activeTransit = fields && fields[`transit_pages_id_${row.id}`] == true;

								const checkboxWrapclasses = type === 'landings'
									? activeLand ? 'checkbox-wrap active' : 'checkbox-wrap'
									: activeTransit ? 'checkbox-wrap active' : 'checkbox-wrap';

								const previewClasses = ['preview__landing'];
								if ((type === 'landings' && (
									fields[`landing_pages_id_${row.id}`] ||
									activeLand &&
									fields.landing_pages == row.id
								)) ||
									(type !== 'landings' && (
										fields[`transit_pages_id_${row.id}`] ||
										activeTransit &&
										fields.transit_pages == row.id
									))) {
									previewClasses.push('active');
								}
								if (isEditMode && !canEdit) previewClasses.push('not-editable');

								return (
									<tr key={row.id}>
										<td className="table-checkbox-area" width={isOtherAdv ? 160 : 150}>

											<div className="preview">
												<label htmlFor={controlId}>
													{ isOtherAdv ?
														(
															<Field className={checkboxWrapclasses}
																name={type === 'landings' ? `landing_pages_id_${row.id}` :`transit_pages_id_${row.id}` }
																shouldCheck={checkboxWrapclasses == 'active'}
																onChange={e=> type === 'landings' &&  checkLandingsPopups(row.id, !e.target.value)}
																shouldDisable={isEditMode && !canEdit}
																component={checkboxField} />
														) : (
															<Field name={type === 'landings' ? 'landing_pages' : 'transit_pages' }
																defaultValue={String(row.id)}
																shouldDisable={(!isOtherAdv && isEditMode) || (isEditMode && !canEdit)}
																component={radioField} />
														)
													}

													<ImagePlaceholdered
														src={row.image}
														alt={type == 'landings' ? 'Landing Preview' : 'Transit Preview'}
														className={previewClasses.join(' ')}
													/>

												</label>
											</div>
										</td>
										<td className={cn({
											'title-date': true,
											'has-labels': !!row.labels.length
										})}>
											<OfferPromoLabels intl={intl} labels={row.labels} />
											<a className="title font-proxima-nova-semibold">
												{row.title} {row.removed && '(removed)'}
											</a>
											{
												get(user, 'language') === 'ru' &&
												row.is_mt_approved &&
												<div className='mt_approved'>Одобрено в МТ</div>
											}
										</td>
										<td className="link">
											<a href={'http://' + row.domain} target="_blank">{row.domain}</a>
										</td>

										<td className="data-value">
											{
												parseFloat(row.cr) > 0 &&
											<span>{formatCrlEpc(parseFloat(row.cr.toFixed(2)))} <i className="currency">%</i></span>
											}
											{(!row.cr || parseFloat(row.cr) <= 0) && <span>{intl('NEW!')}</span>}
										</td>
										<td className="download">
											<DownloadLanding
												language={fields.language && fields.language.value}
												type={row.type}
												domain={row.domain}
												landing_id={row.id}
												isEditMode={isEditMode}
												intl={intl}
												streamId={streamId}
												offerGeoStats={offerGeoStats}
											/>
										</td>
									</tr>
								);
							}) }
							{!data.paginated.isCanNotMoveToNext && data.paginated.data.length
						&& showMore ? showMoreRows(showMore, `${capitalize(type)}Table`, intl) : null
							}
						</tbody>
					</table>
				</Animated>
			</div>
			{ shouldShowSplitTooltip && (
				<Tooltip>
					<span>{intl('При сохранении будет сгенерирован новый ключ сплит-сессии.')}</span>
				</Tooltip>
			)}
		</div>
	);
};

const formatCrlEpc = number => {
	number = number && Number(number) || 0;
	number = number.toFixed(2);
	return number.toString();
};

List.propTypes = {
	data: PropTypes.object,
	type: PropTypes.string,
	isOtherAdv: PropTypes.bool,
	isEditMode: PropTypes.bool,
	canEdit: PropTypes.bool,
	tableHeaders: PropTypes.object,
	sortByColumn: PropTypes.func,
	columnSorting: PropTypes.object,
	showMore: PropTypes.func,
	isCanNotMoveToNext: PropTypes.bool,
	shouldShowSplitTooltip: PropTypes.bool,
	formData: PropTypes.object,
	intl: PropTypes.func,
	checkLandingsPopups: PropTypes.func,
	selectedLandings: PropTypes.array,
	streamId: PropTypes.string,
	user: PropTypes.object
};

export default List;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/components/display-type/list.js